<template>
  <!--
    ไอคอนเครื่องพิมพ์ที่แถบบน — เปิด OffcanvasPrinterSettings (layout เป็นคน mount)
    จุดมุมขวาบนบอกสถานะโดยไม่ต้องเปิดดู:
      เหลือง = เครื่องนี้ยังไม่เคยตั้งค่าเครื่องพิมพ์
      แดง   = ตั้งเป็น Bluetooth แต่ยังไม่ได้เชื่อมต่อ (เปิดแอปใหม่ / เครื่องพิมพ์ปิด / อยู่นอกระยะ)
    สไตล์ปุ่มส่งมาจากที่วาง (แถบบน back-office / sidebar POS / topbar มือถือ แต่งไม่เหมือนกัน)
  -->
  <button
    type="button"
    class="position-relative"
    :class="btnClass"
    :style="btnStyle"
    :title="dot ? $t(dot.label) : $t('Printer Settings')"
    :aria-label="$t('Printer Settings')"
    @click="openPrinterSettings"
  >
    <i class="fa-solid fa-print"/>
    <span
      v-if="dot"
      class="position-absolute top-0 start-100 translate-middle p-1 border border-light rounded-circle"
      :class="dot.bg"
    >
      <span class="visually-hidden">{{ $t(dot.label) }}</span>
    </span>
  </button>
</template>

<script>
import { printerSettings, openPrinterSettings } from '@/utils/printerSettings';
import { bluetoothStatus } from '@/utils/bluetoothPrinter';

export default {
  name: 'PrinterSettingsButton',
  props: {
    btnClass: { type: [String, Array, Object], default: '' },
    btnStyle: { type: [String, Object], default: '' },
  },
  data() {
    return { settings: printerSettings, bt: bluetoothStatus };
  },
  computed: {
    dot() {
      if (!this.settings.configured) {
        return { bg: 'bg-warning', label: '_printer.This device has not been set up yet' };
      }
      if (this.settings.transport === 'bluetooth' && !this.bt.connected) {
        return { bg: 'bg-danger', label: '_printer.Bluetooth printer not connected' };
      }
      return null;
    },
  },
  methods: {
    openPrinterSettings,
  },
};
</script>
